import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Div } from 'ui';
import { withRouter } from 'utils/withRouter';
import CreateOrderContainer from './create-order-container';

class CreateOrders extends Component {
  constructor(props) {
    super();
    const { match } = props;
    const ids = match.params.ids.split(',');
    this.state = {
      ids,
      position: 0,
      redirectIds: [],
    };
  }

  next = (redirectId) => {
    const { history } = this.props;
    const { ids, position, redirectIds } = this.state;
    const newPosition = position + 1;
    const newRedirectIds = [...redirectIds, redirectId];
    if (newPosition === ids.length) {
      const newIds = newRedirectIds && newRedirectIds?.map(o => encodeURIComponent(o));
      history.push(`/order/${newIds.join(',')}`, { context: newRedirectIds[0] });
    } else {
      this.setState({ position: newPosition, redirectIds: newRedirectIds });
    }
  };

  goToDashboard = () => {
    const { history } = this.props;
    history.back();
  };

  render() {
    const { ids, position } = this.state;
    return (
      <CreateOrderContainer
        id={ids[position]}
        next={this.next}
        goToDashboard={this.goToDashboard}
        progressLabel={
          <Div flex={1}>
            {position + 1}/{ids.length}
          </Div>
        }
      />
    );
  }
}

CreateOrders.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(CreateOrders);
